import React from 'react';
import styles from './index.module.scss';

import Wave from '../Wave';
import { ReactComponent as CollapseIcon } from 'assets/img/icons/collapse-icon.svg';
import { UiKit } from 'components';

export default function Menu({ onToggle = () => {}, children = null }) {
  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <div className={styles.backsplash}>
          <Wave />
        </div>
        <div className={styles.header}>
          <h4>Setup Checklist</h4>
          <UiKit.Button
            size="sm"
            variant="ghost"
            onClick={onToggle}
            className={styles.collapseBtn}
          >
            <CollapseIcon width="24" height="24" />
          </UiKit.Button>
        </div>
        <div className={styles.menu}>{children}</div>
      </div>
    </div>
  );
}
